import { IGlobalConfig } from './IGlobalConfig';

declare let WS_GLOBAL_IP: string;
declare let WS_APP_DOMAIN: string;
declare let WS_PUBLIC_DOMAIN: string;
declare let PARTNER_MODE: string;

let globalConfig: IGlobalConfig = {
    api: '',
    appDomain: '',
    publicDomain: '',
    recaptchaPublicKey: '',
    partnerMode: false,
    pageSize: 10,
    maxPageSize: 1000,
};

const variableIsDefined = (variable: any) => typeof variable !== 'undefined';
const parseBooleanVariable = (variable: any) => variableIsDefined(variable) && !!variable && variable !== 'false';
const parseStringVariable = (variable: any, defaultValue: string) => {
    return variableIsDefined(variable) && variable ? variable : defaultValue;
}

try {
    globalConfig.api = parseStringVariable(WS_GLOBAL_IP, 'https://admin.test.mir-khv.ru/api');
} catch (e) {
    globalConfig.api = 'https://admin.test.mir-khv.ru/api';
}

try {
    globalConfig.appDomain = parseStringVariable(WS_APP_DOMAIN, 'https://admin.test.mir-khv.ru');
} catch (e) {
    globalConfig.appDomain = 'https://admin.test.mir-khv.ru';
}

try {
    globalConfig.publicDomain = parseStringVariable(WS_PUBLIC_DOMAIN, 'https://test.mir-khv.ru');
} catch (e) {
    globalConfig.publicDomain = 'https://test.mir-khv.ru';
}

try {
    globalConfig.partnerMode = parseBooleanVariable(PARTNER_MODE);
} catch (e) {
    globalConfig.partnerMode = false;
}

export { globalConfig };
